var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41301 14.3736C8.18634 14.4536 7.81301 14.4536 7.58634 14.3736C5.65301 13.7136 1.33301 10.9602 1.33301 6.29356C1.33301 4.23356 2.99301 2.56689 5.03967 2.56689C6.25301 2.56689 7.32634 3.15356 7.99967 4.06023C8.67301 3.15356 9.75301 2.56689 10.9597 2.56689C13.0063 2.56689 14.6663 4.23356 14.6663 6.29356C14.6663 10.9602 10.3463 13.7136 8.41301 14.3736Z",
    fill: "#F21515",
    stroke: "#F9FAFB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.daa6450580c7d54d62cd1b8b5b104d25.svg";
export { ForwardRef as ReactComponent };